import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import store from '@/store'
import {getToken} from './auth'
import qs from 'qs'
// create an axios instance
var BASE_API = '/';
// var BASE_API = 'http://df.daifabashi.cn/';

const service = axios.create({
    baseURL: BASE_API, // api 的 base_url
    timeout: 30000 // request timeout
})

function clearNullKey(obj) {
    for (const key in obj) {
        if (obj[key] === null || obj[key] === '') {
            delete obj[key]
        }
    }
    return obj
}

// request interceptor
service.interceptors.request.use(
    config => {
        const token = getToken()
        config.data = clearNullKey(config.data)
        config.data = qs.stringify(config.data);

        config.headers = {'Content-Type': 'application/x-www-form-urlencoded'}
        if (token != undefined) {
            Object.assign(config.headers, {'header-token': token})
        }
        return config
    },
    error => {
        // Do something with request error
        console.log('request', error) // for debug
        Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code === 401) {
            MessageBox('登陆过期，请重新登陆', 'access过期', {
                confirmButtonText: '确定',
                type: 'error'
            }).then(() => {
                store.dispatch('FedLogOut');
            })
        } else if (res.code !== 1) {
            if(res.msg){
                if(res.msg.indexOf('认证尚未开始') == -1){
                    Message.error(res.msg)
                }
            }
            Promise.resolve(res)
        }
        // if (response.status === 400 || response.status === 500) {
        //     Message.error(res.message)
        //     Promise.resolve(res)
        // }
        return res
    },

    error => {
        if(error.response.data.code === 401){
            store.dispatch('FedLogOut');
        }else{
            if (error.response !== undefined || error.response !== null) {
                Message({
                    message: error || error.response.data.msg,
                    type: 'error',
                    duration: 10 * 1000
                })
                return Promise.reject('response', error.response.data)
            } else {
                Message({
                    message: error.msg,
                    type: 'error',
                    duration: 10 * 1000
                })

                return Promise.reject('response', error)
            }
        }
    }
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js